import dayjs from 'dayjs';
import { getFromLocalStorage } from 'utils/helpers';

// GLOBAL VARIABLES ************************************************************
// *****************************************************************************

const MODULE_ID = 'appmultiQuotations';
const MODULE_API = '/v1/quotation';

// MODULE PARAMETERS ***********************************************************
// *****************************************************************************

const MULTI_QUOTATIONS_MODULE = {
  id: MODULE_ID,
  noBlockScreenWithAppNotConfigured: false,
  api: MODULE_API,
  urlCustomForm: null,
  defaultUrlQueryString: null,

  components: {
    // list
    dashboard: null,
    list: null,
    grid: null,
    kanban: null,
    filter: null,

    // form
    form: null,
    formHeaderTitle: null,
    formHeaderSubtitle: null,
    formHeaderColumn1: null,
    formHeaderColumn2: null,
    formHeaderColumn3: null,
    formHeaderTags: null,
    formHeaderCustomIcons: null,

    // module Parameters
    parameters: null,

    // module data import
    dataImport: null,

    // data preview
    previewHeader: null,
    previewBody: null,
    previewActions: null,
  },

  methods: {
    decorateDocument,
    // canEditDocument
    // decorateParameters,
  },

  initialRequest: {
    folder: 'documents',

    folderOptions: ['documents', 'recycle', 'filed'],

    filter: null,

    pagination: {
      pageNumber: 1, // current page
      pageSize: getFromLocalStorage('pageSize'),
    },

    paginationOptions: {
      pageSize: [10, 20, 50, 100],
    },

    sorter: {
      '_metadata.audit.updatedAt': -1,
    },

    sorterOptions: ['name', '_metadata.audit.updatedAt', 'destiny', 'status'],

    search: {},

    textSearch: {},
  },

  listState: {
    override: false,
    hideBreadcrumb: false,

    showParameters: false,
    showDataImport: false,

    initTab: null,
    viewMode: ['list'], // 'list', 'kanban', 'grid' or 'dashboard'
    showNumberOfLine: false, // show number of line in table list
    showCheckBoxes: false, // show check boxes on table list for multiple selection
    hasFilter: true, // show the filter (folders and customs) drawer button
    hasAccessControl: true, // show the control access modal for this module
    isTableChanged: false, // detect if the table was changed, check if the currentQs is different of initialQs (includes column sorter, search and pagination)
    isFilterChanged: false, // detect if the filters was changed
    fieldsForRegex: [],
    textSearchInDrawer: true, // inform that the textSearch field is into Drawer Filter to mark the filter button as danger (red)
    refreshDataOfList: 0,
  },

  documentState: {
    showParameters: false,

    disableLockForEdit: false,
    initTab: 'items',
    fieldName: 'name',
    newDocumentTitle: 'new_quotation',
    autoFill: false,
    actions: [],
    refreshParametersOnSave: true,
    indexes: [],

    refreshDataOfDocument: 0,
    mockDocument: {
      date: '',
      destiny: 'central_america',
      __travelPeriod: [dayjs('2023-12-20'), dayjs('2024-01-15')],
      days: 26,

      email: 'caca@biruel.com',
      name: 'Carol C. Biruel',
      phone: '19982320123',
    },
  },
};

// EXPORT ********************************************************************
// ***************************************************************************

export default MULTI_QUOTATIONS_MODULE;

// INTERNAL FUNCTIONS ========================================================
// ===========================================================================

function decorateDocument(doc) {
  // departure and arrival dates decoration
  if (!doc?.departure || !doc?.arrival) return doc;
  doc.__travelPeriod = [dayjs(doc.departure), dayjs(doc.arrival)];
  doc.days = dayjs(doc.arrival).diff(doc.departure, 'days') + 1;

  // return
  return doc;
}
